import React from "react";
import { FAQPage } from "../../../../components/template/CustomTemplate/Pages/FAQ";
import CustomTemplates from "../../Deals/CustomTemplate";

const FaqPage = () => {
  return <CustomTemplates slug={"faq"} attributes={FAQPage} />;
};

export default FaqPage;
